import { Component } from '@angular/core';
import { AuthFactoryService } from 'src/app/auth/authFactory.service';

@Component({
  selector: 'app-unauthorized-container',
  templateUrl: './unauthorized-container.component.html',
  styleUrls: ['./unauthorized-container.component.scss']
})
export class UnauthorizedContainerComponent {
  constructor(private authFactoryService: AuthFactoryService) {}

  goToLogin() {
    this.authFactoryService.redirectToLogin();
  }
}
